import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import TurnstileWidget from '../common/TurnstileWidget';
import { BACKEND_URL } from '../../utils/config';
import './ContactPage.css';

export default function ContactPage() {
  const [form, setForm] = useState({ firstname: '', lastname: '', email: '', message: '', website: '' });
  const [token, setToken] = useState('');
  const [reset, setReset] = useState(0);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState(null);
  const renderedAt = useRef(Date.now());
  const change = e => setForm(f => ({ ...f, [e.target.name]: e.target.value }));
  async function submit(e) {
    e.preventDefault();
    if (sending) return;
    const minimum = /[぀-ヿ㐀-䶿一-鿿豈-﫿가-힯]/.test(form.message) ? 4 : 10;
    if (form.message.trim().length < minimum) { setStatus({ error: 'Please tell us a little more so we can help.' }); return; }
    setSending(true); setStatus(null);
    try {
      const response = await fetch(`${BACKEND_URL}/email-service/contact`, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, renderedAt: renderedAt.current, 'cf-turnstile-response': token })
      });
      const result = await response.json();
      if (!response.ok || result.success === false) throw new Error(typeof result.message === 'string' ? result.message : 'Unable to send your message. Please try again.');
      setStatus({ success: true }); setForm(f => ({ ...f, message: '' })); renderedAt.current = Date.now();
    } catch (error) { setStatus({ error: error.message || 'Unable to send your message. Please try again.' }); }
    finally { setSending(false); setToken(''); setReset(n => n + 1); }
  }
  return <div className="susu-contact-page">
    <header><Link className="contact-brand" to="/">SUSU Closet</Link><nav aria-label="Main navigation"><Link to="/">Home</Link><a href="/#about">About</a><Link to="/my-closet">My closet</Link></nav></header>
    <main><span className="contact-eyebrow">LET’S TALK.</span><h1>Contact us</h1><p>Questions about your closet, sharing your looks, or working together? We’d love to hear from you.</p>
      <form onSubmit={submit} aria-label="Contact us">
        <div className="contact-name-fields">
          <label>First name<input required name="firstname" autoComplete="given-name" maxLength={100} value={form.firstname} onChange={change} /></label>
          <label>Last name<input required name="lastname" autoComplete="family-name" maxLength={100} value={form.lastname} onChange={change} /></label>
        </div>
        <label>Email<input required type="email" name="email" autoComplete="email" maxLength={254} value={form.email} onChange={change} /></label>
        <label>Message<textarea required name="message" rows={6} maxLength={5000} value={form.message} onChange={change} /></label>
        <div className="contact-honeypot" aria-hidden="true"><input name="website" aria-label="Leave empty" tabIndex={-1} autoComplete="off" value={form.website} onChange={change} /></div>
        <TurnstileWidget action="contact" onVerify={setToken} resetSignal={reset} />
        {status?.error && <p role="alert" className="contact-error">{status.error}</p>}
        {status?.success && <p role="status" className="contact-success">Message sent. We’ll get back to you soon!</p>}
        <button disabled={sending} type="submit">{sending ? 'Sending…' : 'Send message'}</button>
        <small>We’ll use your email to reply to your message. <Link to="/privacy">Privacy Policy</Link></small>
      </form>
    </main>
  </div>;
}
